'use strict';

const siteAlert = require('../components/alert');

/**
 * Shows the wishlist result and updates the heart icon.
 * @param {Object} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();

    if (data.success && icon.hasClass('fa-heart-o')) icon.removeClass('fa-heart-o').addClass('fa-heart');

    siteAlert.show({
        type: data.success ? 'success' : 'error',
        message: data.msg,
        timeout: 5000
    });
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();

            const icon = $(this).find($('i'));
            const url = $(this).attr('href');
            const pid = $(this).closest('.product').data('pid');
            let optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            let optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');

            optionId = optionId || null;
            optionVal = optionVal || null;

            if (!url || !pid) return;

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, icon);
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon);
                }
            });
        });
    }
};
